import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderMenuLink, HeaderMenuService } from '../header-menu.service';
import { TranslatePipe } from '../../custom-pipes/translate-pipe/translate.pipe';

@Component({
    selector: 'app-header-search',
    templateUrl: './header-search.component.html',
    styleUrls: ['./header-search.component.css']
})
export class HeaderSearchComponent implements OnInit {
    searchText = '';
    results: HeaderMenuLink[] = [];
    showResults = false;

    constructor(
        private headerMenuService: HeaderMenuService,
        private router: Router,
        private translate: TranslatePipe
    ) { }

    ngOnInit(): void {
        this.headerMenuService.loadMenus();
    }

    onSearchChange(): void {
        const query = (this.searchText || '').trim().toLowerCase();

        if (!query) {
            this.results = [];
            this.showResults = false;
            return;
        }

        this.results = this.headerMenuService.getFlatLinks().filter(function (link) {
            const label = (this.translate.transform(link.labelKey) || '').toLowerCase();
            const section = (this.translate.transform(link.sectionKey) || '').toLowerCase();
            return label.indexOf(query) !== -1 || section.indexOf(query) !== -1;
        }, this).slice(0, 8);

        this.showResults = this.results.length > 0;
    }

    openResult(link: HeaderMenuLink): void {
        this.showResults = false;
        this.searchText = '';

        if (link.qsParameters) {
            this.router.navigate([link.path], { queryParams: { q: link.qsParameters } });
        } else {
            this.router.navigate([link.path]);
        }
    }

    onFocus(): void {
        if (this.searchText.trim()) {
            this.onSearchChange();
        }
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (!target.closest('.header-search-wrap')) {
            this.showResults = false;
        }
    }
}
